import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../../services/account.service';
import { AlertService, MessageSeverity } from '../../services/alert.service';
import { Subscription } from 'rxjs';
import { Utilities } from '../../services/utilities';

@Component({
    selector: 'reset-password',
    template: require('./reset-password.component.html'),
    styles: [require('./reset-password.component.css')]
})
export class ResetPasswordComponent implements OnInit, OnDestroy {

    private subscribers: Subscription[] = [];

    id: string = '';
    newPassword: string = '';
    confirmPassword: string = '';
    isPasswordReset = false;
    isProcessing = false;

    constructor(private activatedRoute: ActivatedRoute, private alertService: AlertService,
        private router: Router, private accountService: AccountService, ) {
    }

    ngOnInit() {
        this.isProcessing = true;
        this.alertService.startLoadingMessage('Gebruikersidentiteit verifiëren om het wachtwoord te wijzigen', 'Reset Wachtwoord');
        this.id = this.activatedRoute.snapshot.params["id"];
        const verificationKey = this.activatedRoute.snapshot.params["vkey"];
        if (this.id && verificationKey) {
            this.verifyUserIdentity(verificationKey);
        } else {
            this.unauthorizedRequest();
        }
    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    verifyUserIdentity(verificationKey: string) {
       const verifypswsSubscriber = this.accountService.verifyChangePasswordIdentity(this.id, verificationKey).subscribe(response => {
            if (response) {
                this.alertService.stopLoadingMessage();
                this.isProcessing = false;
            } else {
                this.unauthorizedRequest();
            }
        }, error => {
            this.unauthorizedRequest();
            });

        this.subscribers.push(verifypswsSubscriber);
    }

    private unauthorizedRequest() {
        this.alertService.stopLoadingMessage();
        this.isProcessing = false;
        this.alertService.showStickyMessage('Reset Wachtwoord', 'U bent niet bevoegd om het wachtwoord te wijzigen', MessageSeverity.warn);
        this.router.navigate(['/login']);
    }

    resetPassword(form: NgForm) {
        if (form.valid) {
            if (this.newPassword !== this.confirmPassword) {
                this.alertService.showMessage('Paswoord', 'Wachtwoord en wachtwoord bevestigen komen niet overeen.', MessageSeverity.error);
            } else {


                const resetLinkSubscriber = this.accountService.resetPassword(this.id, this.newPassword).subscribe((res) => {
                    this.isPasswordReset = true;

                }, error => {

                    this.isPasswordReset = true;

                    let errorMessage = Utilities.findHttpResponseMessage("error_description", error);

                    if (errorMessage)
                        this.alertService.showStickyMessage("Waarschuwing", errorMessage, MessageSeverity.warn, error);
                    else
                        this.alertService.showStickyMessage("Fout", "Er is een fout opgetreden.Probeer het later nogmaals.\nError: " + error.statusText || error.status, MessageSeverity.error, error);

                });

                this.subscribers.push(resetLinkSubscriber);
                
            }
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/reset-password/reset-password.component.ts